import { Checkbox } from 'antd';
import styled from 'styled-components';

export const TemplateSelectWrapper = styled.div`
  order: 1;
`;

export const TemplateCardWrapper = styled.div`
  order: 3;
`;

export const RememberFieldsCheckbox = styled(Checkbox)`
  order: 3;
`;
